import { Component, signal, inject, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { routeTransition } from './shared/animations/animations';
import { LanguageService } from './core/services/language.service';
import { TranslationService } from './core/services/translation.service';
import { Directionality } from '@angular/cdk/bidi';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  animations: [routeTransition],
})
export class App implements OnInit, OnDestroy {
  private languageService = inject(LanguageService);
  private translationService = inject(TranslationService);
  private directionality = inject(Directionality);
  private cdr = inject(ChangeDetectorRef);
  private destroy$ = new Subject<void>();

  protected readonly title = signal('Servvis Admin');

  ngOnInit() {
    const currentLanguage = this.languageService.getCurrentLanguage();
    this.translationService.use(currentLanguage.code).subscribe({
      next: () => {
        const language = this.languageService
          .getSupportedLanguages()
          .find((lang) => lang.code === currentLanguage.code);
        if (language) {
          this.directionality.change.emit(language.direction);
        }
      },
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
